import * as React from 'react';
import { camelizeKeys } from 'humps';
import monolithApolloClient from '~/monolith/monolithApolloClient';

const exitSurveyQuery = require('./query.policygenius.graphql');

type childrenProps = {
  exitSurveySources?: any | null;
  loading: boolean;
};

interface Props {
  children: (props: childrenProps) => any;
}

interface State {
  exitSurveySources?: any | null;
}

class MetadataQuery extends React.PureComponent<Props, State> {
  state: State = {
    exitSurveySources: null,
  };

  componentDidMount() {
    monolithApolloClient
      .query({
        query: exitSurveyQuery,
      })
      .then((data: any) => {
        const formattedData: any = camelizeKeys(data.data.metadata);

        this.setState({
          exitSurveySources: formattedData.exitSurveySources,
        });
      });
  }

  render() {
    const { children } = this.props;
    const { exitSurveySources } = this.state;

    return children({
      ...this.props,
      exitSurveySources,
      loading: !exitSurveySources,
    });
  }
}

export default MetadataQuery;
